import { ListParameters } from '../BaseTypes';
import { ValueLabelOptionTyped } from '../ui';
export const ItemTypeIndicatorMap = new Map<string, string>([
  ['1', 'NSN'],
  ['2', 'Part Number'],
]);

export const ItemTypeIndicatorOptions = [...ItemTypeIndicatorMap.keys()].map(
  d => {
    return {
      value: d,
      label: ItemTypeIndicatorMap.get(d),
    };
  }
);

export const SmallBusinessSetAsideIndicatorMap = new Map<string, string>([
  ['Y', 'Small Business'],
  ['H', 'HubZone'],
  ['R', 'Disabled Veteran Business'],
  ['L', 'Woman Owned Business'],
  ['E', 'Econ. Disadvantaged Women Owned Sm Business'],
  ['C', 'Combined'],
  ['N', 'No Set Aside'],
]);

export enum SmallBusinessSetAsideEnum {
  'Y' = 'Y',
  'H' = 'H',
  'R' = 'R',
  'L' = 'L',
  'E' = 'E',
  'C' = 'C',
  'N' = 'N',
}

export const SmallBusinessSetAsideOptions = [
  ...SmallBusinessSetAsideIndicatorMap.keys(),
].map(d => {
  return {
    value: d,
    label: `${d} - ${SmallBusinessSetAsideIndicatorMap.get(d)}`,
  };
});

export const InspectionPointIndicatorMap = new Map<string, string>([
  ['D', 'Destination'],
  ['O', 'Origin'],
]);

export interface PriceHistory {
  cageCode: string;
  contractNumber: string;
  quantity: number;
  unitCost: number;
  awardDate: Date;
}

export enum DLATimeFrameEnum {
  'TODAY' = 'TODAY',
  '3_DAYS' = '3_DAYS',
  '7_DAYS' = '7_DAYS',
  '15_DAYS' = '15_DAYS',
  '30_DAYS' = '30_DAYS',
}

export const DLATimeFrameOptions: Array<ValueLabelOptionTyped<
  DLATimeFrameEnum,
  string
>> = [
  { value: DLATimeFrameEnum.TODAY, label: 'Today' },
  { value: DLATimeFrameEnum['3_DAYS'], label: 'Last 3 Days' },
  { value: DLATimeFrameEnum['7_DAYS'], label: 'Last 7 Days' },
  { value: DLATimeFrameEnum['15_DAYS'], label: 'Last 15 Days' },
  { value: DLATimeFrameEnum['30_DAYS'], label: 'Last 30 Days' },
];

export enum DLAExtendedPriceEnum {
  'ANY_PRICE' = 'ANY_PRICE',
  'PRICE_0_1000' = 'PRICE_0_1000',
  'PRICE_1000_10000' = 'PRICE_1000_10000',
  'PRICE_10000_50000' = 'PRICE_10000_50000',
  'PRICE_50000_PLUS' = 'PRICE_50000_PLUS',
}

export const DLAExtendedPriceOptions = [
  { value: DLAExtendedPriceEnum.ANY_PRICE, label: 'Any Price' },
  { value: DLAExtendedPriceEnum.PRICE_0_1000, label: '$0 - $1,000' },
  { value: DLAExtendedPriceEnum.PRICE_1000_10000, label: '$1,000 - $10,000' },
  { value: DLAExtendedPriceEnum.PRICE_10000_50000, label: '$10,000 - $50,000' },
  { value: DLAExtendedPriceEnum.PRICE_50000_PLUS, label: '$50,000+' },
];

export enum DLAQuantityEnum {
  ANY_QUANTITY = 'ANY_QUANTITY',
  QTY_1_10 = 'QTY_1_10',
  QTY_11_50 = 'QTY_11_50',
  QTY_50_100 = 'QTY_50_100',
  QTY_100_PLUS = 'QTY_100_PLUS',
}

export const DLAQuantityOptions = [
  { value: DLAQuantityEnum.ANY_QUANTITY, label: 'Any Quantity' },
  { value: DLAQuantityEnum.QTY_1_10, label: '1-10' },
  { value: DLAQuantityEnum.QTY_11_50, label: '11-50' },
  { value: DLAQuantityEnum.QTY_50_100, label: '50-100' },
  { value: DLAQuantityEnum.QTY_100_PLUS, label: '100+' },
];
export interface DLAListParameters extends ListParameters {
  fromDate?: DLATimeFrameEnum;
  setAside?: keyof typeof SmallBusinessSetAsideOptions;
  quantity?: DLAQuantityEnum;
  extendedPrice?: DLAExtendedPriceEnum;
}

export interface DLASolicitation {
  _id?: string;
  solicitationNumber: string;
  solicitationDate: Date;
  filename: string;
  nsn: string;
  createdAt: Date;
  purchaseRequestNumber: string[];
  returnByDate: Date;
  quantity: number;
  unitIssue: string;
  description: string;
  buyerCode: string;
  acquisitionMethodSuffixCode: string;
  itemTypeIndicator: string;
  smallBusinessSetAsideIndicator: string;
  smallBusinessSetAsidePercent: number;
  itemDescriptionIndicator?: string;
  inspectionPoint?: string;
  fobPoint?: string;
  deliveryDays?: number;
  jcpRequired?: boolean;
  qaCertificationRequired?: boolean;
  naicsCode?: string;
  priceHistory?: PriceHistory[];
  solicitationDocumentId?: string;
  state: DLAState;
}

export const enum SolicitationActionMenuOption {
  CREATE_RFQ = 'Create RFQ',
  VIEW_TECHDOCS = 'View Tech Drawings',
  NO_QUOTE_RFQ = 'No Quote',
}

export enum DLAState {
  'NO_QUOTE' = 'NO_QUOTE',
  'RFQ_CREATED' = 'RFQ_CREATED',
  'NEW' = 'NEW',
}
export const DLAStateOptions = [
  { value: DLAState.NO_QUOTE, label: 'No Quote' },
  { value: DLAState.NEW, label: 'New' },
  { value: DLAState.RFQ_CREATED, label: 'RFQ Created' },
];

export const DLAStateMap = {
  [DLAState.NEW]: 'New',
  [DLAState.NO_QUOTE]: 'No Quote',
  [DLAState.RFQ_CREATED]: 'RFQ Created',
};
